import { Component } from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'dialog-result-example-dialog',
  template: `<h1 md-dialog-title>{{ title }}</h1>
    <div md-dialog-content style="padding-bottom: 20px;" [innerHTML]="text | sanitize"></div>
    <div md-dialog-actions style='justify-content: center;'>
     <ng-template ngFor let-button [ngForOf]="buttons">
        <button md-button (click)="dialogRef.close(button)">{{button.title}}</button>
  </ng-template>
    </div>`,
})
export class DialogResultComponent {
  title: string;
  text: string;
  buttons: any;
  constructor(public dialogRef: MdDialogRef<DialogResultComponent>) {
    this.title = this.dialogRef._containerInstance.dialogConfig.data.title;
    this.text = this.dialogRef._containerInstance.dialogConfig.data.text;
    this.buttons = this.dialogRef._containerInstance.dialogConfig.data.buttons;
  }

}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/shared/component/dialog-result.component.ts